document.addEventListener('DOMContentLoaded', function() {
  const animatedTitles = document.querySelectorAll('.animated-title');
  const underlineItems = document.querySelectorAll('.underline-item');
  const animatedTitlesContainer = document.querySelector('.animated-titles');
  const titleUnderline = document.querySelector('.title-underline');
  let currentIndex = 0;
  let typingSpeed = 80; // Typing speed in ms (slower)
  let deletingSpeed = 50; // Deleting speed in ms (slower)
  let pauseDuration = 2000; // Pause between words in ms (longer)
  let isTyping = false;
  let cursorVisible = true;
  const cursor = '<span class="cursor"></span>'; // Cursor with class for individual styling
  
  // Save the original texts of the titles
  const originalTexts = [];
  
  const filledTitles = Array.from(animatedTitles).filter(title => {
    const text = title.textContent.trim();
    if (text !== '') {
      originalTexts.push(text);
      // Empty the content for the typewriter effect
      title.innerHTML = '';
      return true;
    }
    return false;
  });
  

  if (underlineItems.length > 0) {
    underlineItems.forEach((item, index) => {
      if (index === 0) {
        item.style.opacity = '1';
        item.style.visibility = 'visible';
      } else {
        item.style.opacity = '0';
        item.style.visibility = 'hidden';
      }
    });
  }
  
  if (animatedTitles[0]) {
    // Make sure the first title is visible
    animatedTitles[0].classList.add('active');
    animatedTitles[0].style.opacity = '1';
    animatedTitles[0].style.visibility = 'visible';
    updateUnderline();
    // Start the typewriter effect for the first title
    typeText(animatedTitles[0], originalTexts[0], 0);
  }
  
  function updateUnderline() {
    const activeTitle = document.querySelector('.animated-title.active');
    if (activeTitle && titleUnderline) {
      const width = activeTitle.offsetWidth;
      const position = activeTitle.offsetLeft;
      
      titleUnderline.style.width = width + 'px';
      titleUnderline.style.left = position + 'px';
      
      animatedTitlesContainer.style.minWidth = width + 'px';
    }
  }
  
  // Function to write text character by character
  // Function to make the cursor blink
  function blinkCursor() {
    cursorVisible = !cursorVisible;
    const activeTitle = document.querySelector('.animated-title.active');
    if (activeTitle) {
      // Use regular expression to remove the cursor
      const textWithoutCursor = activeTitle.innerHTML.replace(/<span class="cursor".*?<\/span>/g, '');
      activeTitle.innerHTML = cursorVisible ? textWithoutCursor + cursor : textWithoutCursor;
    }
  }
  
  // Start the cursor blinking
  const cursorInterval = setInterval(blinkCursor,500);
  
  function typeText(element, text, charIndex) {
    if (!element) return;
    
    // Make sure isTyping is true
    isTyping = true;
    
    // Remove the cursor before adding the next character
    const textWithoutCursor = element.innerHTML.replace(/<span class="cursor".*?<\/span>/g, '');
    
    if (charIndex < text.length) {
      element.innerHTML = textWithoutCursor + text.charAt(charIndex) + cursor;
      updateUnderline();
      setTimeout(() => typeText(element, text, charIndex + 1), typingSpeed);
    } else {
      // When finished typing, wait before deleting
      setTimeout(() => deleteText(element, text), pauseDuration);
    }
  }
  
  // Function to delete text character by character
  function deleteText(element, text) {
    if (!element) return;
    
    const currentText = element.innerHTML.replace(/<span class="cursor".*?<\/span>/g, '');
    if (currentText.length > 0) {
      element.innerHTML = currentText.slice(0, -1) + cursor;
      updateUnderline();
      setTimeout(() => deleteText(element, text), deletingSpeed);
    } else {
      // When finished deleting, change to the next title
      showNextTitle();
    }
  }
  
  function showNextTitle() {
    // Hide the current title
    if (animatedTitles[currentIndex]) {
      animatedTitles[currentIndex].classList.remove('active');
      animatedTitles[currentIndex].style.opacity = '0';
      animatedTitles[currentIndex].style.visibility = 'hidden';
      
      if (underlineItems[currentIndex]) {
        underlineItems[currentIndex].style.opacity = '0';
        underlineItems[currentIndex].style.visibility = 'hidden';
      }
    }
    
    // Change to the next title
    currentIndex = (currentIndex + 1) % filledTitles.length;
    
    if (animatedTitles[currentIndex]) {
      // Make sure the title is empty at the beginning and only has the cursor
      animatedTitles[currentIndex].innerHTML = cursor;
      animatedTitles[currentIndex].classList.add('active');
      // Make sure the title is visible
      animatedTitles[currentIndex].style.opacity = '1';
      animatedTitles[currentIndex].style.visibility = 'visible';
      
      if (underlineItems[currentIndex]) {
        underlineItems[currentIndex].style.opacity = '1';
        underlineItems[currentIndex].style.visibility = 'visible';
      }
      
      updateUnderline();
      
      // Start typewriter effect for the new title
      // Small pause before starting to type the new title
      setTimeout(() => {
        typeText(animatedTitles[currentIndex], originalTexts[currentIndex], 0);
      }, 300);
    }
  }
  
  if (filledTitles.length > 1) {
    isTyping = true;
    // We don't use setInterval because the change is handled by the typewriter effect
  }
  
  window.addEventListener('resize', updateUnderline);
});